<app-header *ngIf="headerContent" [headerContent]="headerContent" [themeContent]="themeContent"></app-header>
<app-form-dynamic-v1 *ngIf="formFlowConfig" [formFlow]="formFlowConfig" [themeContent]="themeContent"></app-form-dynamic-v1>
<app-articles *ngIf="articlesConfig" [articlesContent]="articlesConfig" [themeContent]="themeContent"></app-articles>
<app-footer *ngIf="footerContent" [footerContent]="footerContent" [themeContent]="themeContent"></app-footer>

